import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import LIST_ITEM from './list-item.palette-schema.yaml';

registerTileSchema(LIST_ITEM);

export function generateLinkMenuVerticalList(TILE) {
    const ITEM_BORDER_STYLE = TILE.LIST_ITEM_SHOW_SEPARATOR
        ? {
              borderWidth: '0 0 1px 0',
              borderColor: TILE.LIST_ITEM_SEPARATOR_COLOR,
              borderStyle: 'solid',
          }
        : undefined;

    return {
        icon: {
            style: {
                padding: '0px 0px 0px 8px',
                minHeight: 24,
                minWidth: 24,
                fill: TILE.LIST_ITEM_ICON_COLOR,
            },
        },
        headerContainer: {
            style: {
                height: 40,
                alignItems: 'center',
            },
        },
        regularItem: {
            unselected: {
                style: {
                    base: {
                        padding: 8,
                        alignItems: 'center',
                        minHeight: 40,
                        ...TILE.LIST_ITEM_TEXT,
                        ...ITEM_BORDER_STYLE,
                    },
                },
            },
            indicator: {
                style: {
                    base: {
                        height: 0,
                        backgroundColor: 'transparent',
                    },
                },
            },
        },
        regularLabel: {
            style: {
                overflowWrap: 'anywhere',
            },
        },
    };
}

export function generateSelectableButtonVerticalList(TILE) {
    const SEPARATOR = TILE.LIST_ITEM_SHOW_SEPARATOR
        ? {borderWidth: '0 0 1px 0', borderStyle: 'solid', borderColor: TILE.LIST_ITEM_SEPARATOR_COLOR}
        : {};

    return {
        selected: {
            style: {
                base: {
                    padding: 8,
                    alignItems: 'center',
                    minHeight: '40px',
                    ...SEPARATOR,
                    ...TILE.LIST_ITEM_SELECTED_TEXT,
                    ...resolveBackground(TILE.LIST_ITEM_SELECTED_BG),
                },
            },
        },
        unselected: {
            style: {
                base: {
                    padding: 8,
                    alignItems: 'center',
                    minHeight: '40px',
                    ...SEPARATOR,
                    ...TILE.LIST_ITEM_TEXT,
                },
            },
        },
    };
}
